import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNASelect } from '@alucio/lux-ui';
import { useSlideRollState } from '../SlideRollProvider';

const styles = StyleSheet.create({
  meetingGroupSelection: {
    marginBottom: 10,
    width: 340,
  },
});

const GroupSelection: React.FC = () => {
  const {
    displayGroupSelection,
    groups,
    selectedGroupIndex,
    selectedGroupValue,
    onGroupSelect,
  } = useSlideRollState();

  if (!displayGroupSelection) return null;
  return (
    <DNABox alignY="center" childFill>
      <DNASelect
        style={styles.meetingGroupSelection}
        selectedIndex={selectedGroupIndex}
        value={selectedGroupValue}
        onSelect={onGroupSelect}
      >
        {[
          <DNASelect.Item key="allSlides" title="All slides" />,
          ...groups.map(group => (
            <DNASelect.Item key={group.model.id} title={group.model.name} />
          )),
        ]}
      </DNASelect>
    </DNABox>
  )
};

export default GroupSelection;
